import React, { useEffect, useState } from "react";
import DashboardFooter from "./DashboardFooter";
import { BiToggleLeft } from "react-icons/bi";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { UPDATE_USER_NAMES } from "../../apollo/operations";
import { useMutation } from "@apollo/client";
import { showToast } from "../../utils/showToast";
import { useSelector } from "react-redux";
import Loading from "../loading/Loading";
import { NotificationSettings } from "..";

type SettingProps = {
  refetch?: any;
};

const Setting: React.FC<SettingProps> = ({ refetch }) => {
  const [oldPassword, setOldPassword] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [passwordMatch, setPasswordMatch] = useState<boolean>(true);

  const [username, setUsername] = useState<string>("");
  const [usernamePassword, setUsernamePassword] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const checkPasswordMatch = () => {
    if (password === confirmPassword) {
      setPasswordMatch(true);
    } else {
      setPasswordMatch(false);
    }
  };

  useEffect(() => {
    checkPasswordMatch();
  }, [confirmPassword]);

  const user = useSelector((state: any) => state.user.userDetails);

  const [
    updateUserNames,
    { data: updateNamesData, loading: updateNamesLoading },
  ] = useMutation(UPDATE_USER_NAMES, {
    onCompleted(data) {
      // console.log(data.updateUser);
      showToast("Profile updated successfully", "success");
    },
    onError(error) {
      console.log(error);
      console.log(error);
      console.log(error.message);
      showToast(error.message, "error");
      if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        // console.log(error.graphQLErrors);

        const errorMessage = error.graphQLErrors[0]?.extensions?.originalError;
        console.error("GraphQL Error:", errorMessage);
      }
    },
  });

  const handlePasswordChange = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    checkPasswordMatch();
    if (passwordMatch) {
      updateUserNames({
        variables: {
          data: {
            oldPassword: oldPassword,
            password: password,
          },
          where: {
            id: user.id,
          },
        },
      });
    }
    refetch();
    setLoading(false);
  };

  const handleUsernameChange = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    updateUserNames({
      variables: {
        data: {
          username: username,
          oldPassword: usernamePassword,
        },
        where: {
          id: user.id,
        },
      },
    });
    setLoading(false);
    refetch();
  };

  if (loading) return <Loading loading={loading} />;
  if (updateNamesLoading) return <Loading loading={updateNamesLoading} />;
  return (
    <div className="w-full bg-[#F6F7F9] py-20  ">
      <div className="w-[90%] max-w-7xl mx-auto border border-[#b9b9b9] bg-white rounded-xl lg:rounded-3xl ">
        <div className="flex flex-col p-7 gap-[50px]">
          {/* CHANGE EMAIL */}
          {/* <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[14px] md:text-[16px] lg:text-[20px] leading-4 lg:leading-7 ">
                Change your email
              </p>
              <span className=" w-[70%] lg:w-[80%] border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                New Email
              </label>
              <input
                type="email"
                placeholder="e.g: newemail@usermail.com"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                Ecomoto password
              </label>
              <input
                type="password"
                placeholder="password"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
              <span className="text-[#585656] font-Poppins text-[7px] lg:text-[10px] font-medium cursor-pointer">
                Forgot your password?
              </span>
            </div>
            <div className="flex flex-col gap-[10px] w-fit ">
              <button
                type="button"
                className="bg-darkGreen font-bold text-white text-center border rounded-xl text-[15px] py-4 px-12 font-Poppins"
              >
                Change your email
              </button>
            </div>
          </div> */}

          {/* NOTIFICATIONS */}

          {/* <NotificationSettings /> */}

          {/* INFORMATIONAL EMAILS */}

          {/* <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[14px] md:text-[16px] lg:text-[20px] leading-4 lg:leading-7 ">
                Informational emails
              </p>
              <span className="w-[75%] border-t border-[#EBE1EB] "></span>
            </div>

            <div className=" flex  justify-between">
              <p className="flex flex-col lg:flex-row gap-2 items-center font-Poppins text-[13px]  lg:text-[16px] text-[#323232] font-medium ">
                Email will be sent to this address:
                <span className="font-Poppins font-light text-[13px]  lg:text-[16px] text-[#323232] ">
                  user@mail.com
                </span>
              </p>

              <p className="text-midGreen font-Poppins text-[12px] lg:text-[20px] font-semibold">
                Edit
              </p>
            </div>

            <div className="flex w-full items-center justify-between">
              <div className="flex flex-col gap-3 w-[70%]">
                <p className=" font-Poppins text-[#323232] text-[10px] md:text-[12px] lg:text-[16px] font-medium leading-4 lg:leading-7">
                  Ecomoto newsletter
                </p>
                <span className=" font-Poppins text-[#646464] text-[8px] lg:text-[12px] font-normal ">
                  Stay informed monthly on Ecomoto news and marketing offers.
                </span>
              </div>
              <div className="flex gap-7 w-[20%] justify-end  ">
                <BiToggleLeft color="#215759" size={30} />
              </div>
            </div>

            <div className="flex w-full items-center justify-between">
              <div className="flex flex-col gap-3 w-[70%]">
                <p className=" font-Poppins text-[#323232] text-[10px] md:text-[12px] lg:text-[16px] font-medium leading-4 lg:leading-7">
                  Account activity
                </p>
                <span className=" font-Poppins text-[#646464] text-[8px] lg:text-[12px] font-normal ">
                  Payment notice, security, ToS updates… These notifications are
                  required to service your account, you cannot disable them.
                </span>
              </div>
              <div className="flex gap-7 w-[20%] justify-end  ">
                <BiToggleLeft color="#215759" size={30} />
              </div>
            </div>
          </div> */}

          {/* CELL NOTIFICATION */}

          {/* <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[14px] md:text-[16px] lg:text-[20px] leading-4 lg:leading-7 ">
                Mobile notification
              </p>
              <span className="w-[75%] border-t border-[#EBE1EB] "></span>
            </div>

            <div className=" flex justify-between">
              <p className="flex gap-2 items-center font-Poppins text-[13px]  lg:text-[16px] text-[#323232] font-medium ">
                SMS notifications will be sent to this number:
              </p>
              <p className="text-midGreen font-Poppins text-[12px] lg:text-[20px] font-semibold">
                Edit
              </p>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <input
                type="tel"
                pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                placeholder="e.g: (555) 555-1234"
                className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
              />
            </div>

            <div className="flex w-full items-center justify-between">
              <div className="flex flex-col gap-3 w-[70%]">
                <p className=" font-Poppins text-[#323232] text-[10px] md:text-[12px] lg:text-[16px] font-medium leading-4 lg:leading-7">
                  Push notifications settings
                </p>
                <span className=" font-Poppins text-[#646464] text-[8px] lg:text-[12px] font-normal ">
                  To get push notifications in the event of a request or
                  booking, download the Ecomoto app. To activate or deactivate
                  these notifications, go to the “settings” section on your cell
                  phone.
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-[10px] w-fit ">
              <button
                type="button"
                className="bg-darkGreen font-bold text-white text-center border rounded-xl text-[15px] py-4 px-12 font-Poppins"
              >
                Update your profile
              </button>
            </div>
          </div> */}

          {/* USERNAME */}
          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[14px] md:text-[16px] lg:text-[20px] leading-4 lg:leading-7 ">
                Change your username
              </p>
              <span className="w-[75%] border-t border-[#EBE1EB] "></span>
            </div>
            <form action="" onSubmit={handleUsernameChange}>
              <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
                <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                  New Username
                </label>
                <input
                  type="text"
                  placeholder="New username"
                  value={username}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setUsername(e.target.value)
                  }
                  className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
                />
              </div>
              <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
                <label className="text-black font-Poppins font-medium text-[10px] lg:text-[16px] leading-4 lg:leading-7 ">
                  Ecomoto password
                </label>
                <input
                  type="password"
                  placeholder="password"
                  value={usernamePassword}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setUsernamePassword(e.target.value)
                  }
                  className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
                />
                <span className="text-[#585656] font-Poppins text-[7px] lg:text-[10px] font-medium cursor-pointer">
                  Forgot your password?
                </span>
              </div>
              <div className="flex flex-col gap-[10px] w-fit ">
                <button
                  type="submit"
                  className="bg-darkGreen font-bold text-white text-center border rounded-xl text-[15px] py-4 px-12 font-Poppins"
                >
                  Change your username
                </button>
              </div>
            </form>
          </div>

          {/* CHANGE PASSWORD */}
          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[14px] md:text-[16px] lg:text-[20px] leading-4 lg:leading-7 ">
                Change your password
              </p>
              <span className="w-[65%] lg:w-[75%] border-t border-[#EBE1EB] "></span>
            </div>
            <form
              action=""
              onSubmit={handlePasswordChange}
              className="flex flex-col gap-4 w-full lg:w-[70%]"
            >
              <div className="flex flex-col gap-5">
                <label
                  htmlFor=""
                  className="text-[#596780] font-Jakarta text-[13px] font-semibold leading-6 "
                >
                  Old Password
                </label>
                <div className="flex items-center justify-between relative">
                  <input
                    placeholder="Current Password"
                    type={showPassword ? "text" : "password"}
                    required
                    value={oldPassword}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setOldPassword(e.target.value)
                    }
                    className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
                  />
                  <span className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                    {showPassword ? (
                      <BsEye
                        className="text-[18px] md:text-[22px] text-[#4A4A4A] cursor-pointer"
                        onClick={togglePasswordVisibility}
                      />
                    ) : (
                      <BsEyeSlash
                        className="text-[18px] md:text-[22px] text-[#4A4A4A] cursor-pointer"
                        onClick={togglePasswordVisibility}
                      />
                    )}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-5">
                <label
                  htmlFor=""
                  className="text-[#596780] font-Jakarta text-[13px] font-semibold leading-6 "
                >
                  New Password
                </label>
                <div className="flex items-center justify-between relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    required
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setPassword(e.target.value)
                    }
                    placeholder="New Password"
                    className="border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
                  />

                  <span className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                    {showPassword ? (
                      <BsEye
                        className="text-[18px] md:text-[22px] text-[#4A4A4A] cursor-pointer"
                        onClick={togglePasswordVisibility}
                      />
                    ) : (
                      <BsEyeSlash
                        className="text-[18px] md:text-[22px] text-[#4A4A4A] cursor-pointer"
                        onClick={togglePasswordVisibility}
                      />
                    )}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-5">
                <label
                  htmlFor=""
                  className="text-[#596780] font-Jakarta text-[13px] font-semibold leading-6 "
                >
                  Confirm Password
                </label>
                <div className="flex items-center justify-between relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={confirmPassword}
                    required
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setConfirmPassword(e.target.value);
                    }}
                    placeholder=" Confirm Password"
                    className={
                      passwordMatch
                        ? "border border-[#ccc] rounded-lg w-full h-[50px] outline-none p-5"
                        : "border  rounded-lg w-full h-[50px] outline-none p-5  border-red-500 "
                    }
                  />
                  <span className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                    {showPassword ? (
                      <BsEye
                        className="text-[18px] md:text-[22px] text-[#4A4A4A] cursor-pointer"
                        onClick={togglePasswordVisibility}
                      />
                    ) : (
                      <BsEyeSlash
                        className="text-[18px] md:text-[22px] text-[#4A4A4A] cursor-pointer"
                        onClick={togglePasswordVisibility}
                      />
                    )}
                  </span>
                </div>
                <p>
                  {passwordMatch ? (
                    ""
                  ) : (
                    <span className="text-red-500 text-[12px]">
                      Passwords do not match
                    </span>
                  )}
                </p>
              </div>
              <button
                type="submit"
                className="bg-darkGreen text-white py-3 rounded-md"
              >
                Submit
              </button>
            </form>
          </div>

          {/* DELETE ACCOUNT */}
          <div className="flex gap-[30px] flex-col  ">
            <div className="flex gap-3 items-center justify-between">
              <p className=" text-black font-Poppins font-semibold text-[14px] md:text-[16px] lg:text-[20px] leading-4 lg:leading-7 ">
                Delete your account
              </p>
              <span className="w-[75%] border-t border-[#EBE1EB] "></span>
            </div>
            <div className="flex flex-col gap-[10px] w-full lg:w-[70%]  ">
              <div className="flex flex-col gap-[10px] w-fit ">
                <button
                  type="button"
                  className="bg-[#E0161612] font- text-[#E01616] border rounded-xl text-[15px] py-4 px-12 font-Poppins"
                >
                  Delete your account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DashboardFooter />
    </div>
  );
};

export default Setting;
